import { useEffect } from 'react';
import NotificationCircle from '../../NotificationCircle/NotificationCircle';
import { Icon } from '../../UI';
import { useNotifications } from '../../../context/Notifications';
import { useSidebar } from '../../../context/Sidebar';
import { Notifications } from './index';

export const NotificationButton = () => {
  const { unreadNotificationsCount, markAlertNotificationsAsRead } =
    useNotifications();

  const { isOpen, setIsOpen, setContent, setTitle, title } = useSidebar();

  const handleClick = () => {
    if (unreadNotificationsCount > 0 && !isOpen) {
      markAlertNotificationsAsRead();
    }

    if (!isOpen || title !== 'NOTIFICATION') {
      setIsOpen(true);
      setTitle('NOTIFICATION');
      setContent(<Notifications />);
    } else {
      setIsOpen(false);
      setTitle('');
    }
  };

  useEffect(() => {
    const audio = new Audio('notification.mp3');
  }, [unreadNotificationsCount]);

  return (
    <div className="relative cursor-pointer">
      <Icon
        className="ml-auto w-4 h-4 text-lg cursor-pointer"
        color="black"
        svgName={'bell'}
        onClick={handleClick}
        id={'notification-button'}
      />
      <NotificationCircle
        count={unreadNotificationsCount}
        classes="absolute -top-3 -right-2"
      />
    </div>
  );
};
